
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"191","height":"92","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".1","fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 0v50.556a6.408 6.408 0 003.983 5.931l68.995 28.196V0H0zm78.764 0v87.24c18.824 10.472 34.225 0 34.225 0V0H78.764zm39.259 0v84.683l68.994-28.196a6.407 6.407 0 003.983-5.93V0h-72.977z","fill":"#0F8190"}})])
          )
        }
      }
    